import { format } from "date-fns";
import { Link } from "react-router-dom";
import { useDeleteUserMutation } from '../usersApiSlice'


export default function UserRow({ user }) {
  const [deleteUser] = useDeleteUserMutation();

  const created = user.createdAt ? format(new Date(user.createdAt), "yyyy-MM-dd") : "—";

  const handleDelete = async () => {
    if (window.confirm(`Are you sure you want to delete user "${user.username}"?`)) {
      try {
        await deleteUser(user._id).unwrap(); // Option B style: id in URL
      } catch (err) {
        console.error('Failed to delete the user:', err);
      }
    }
  };

  return (
    <tr className="hover:bg-gray-50/40">
      <td className="px-6 py-3 text-sm text-gray-900 font-medium">{user.username}</td>
      <td className="px-6 py-3 text-sm text-gray-600">{user.email || "—"}</td>
      <td className="px-6 py-3 text-sm text-gray-600">
        {Array.isArray(user.roles) ? user.roles.map((r) => (
          <span key={r} className="mr-1 rounded-full bg-gray-100 px-2 py-0.5 text-xs text-gray-700 ring-1 ring-inset ring-gray-200">{r}</span>
        )) : user.roles || "—"}
      </td>
      <td className="px-6 py-3">
        {user.active ? (
          <span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-medium text-emerald-700 ring-1 ring-inset ring-emerald-200">
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-500"></span> Active
          </span>
        ) : (
          <span className="inline-flex items-center gap-1 rounded-full bg-rose-50 px-2.5 py-1 text-xs font-medium text-rose-700 ring-1 ring-inset ring-rose-200">
            <span className="h-1.5 w-1.5 rounded-full bg-rose-500"></span> Disabled
          </span>
        )}
      </td>
      <td className="px-6 py-3 text-sm text-gray-600">{created}</td>
      <td className="px-6 py-3 text-sm text-gray-600">{user.customer_id || "—"}</td>
      <td className="px-6 py-3 text-right">
        <div className="inline-flex gap-2">
          <Link
            to={`/dash/users/${user._id}`}  
            className="rounded-xl border border-gray-200 bg-white px-3 py-1.5 text-xs text-gray-700 hover:bg-gray-50"
          >
            Edit
          </Link>
          <button
            onClick={handleDelete}
            className="rounded-xl border border-gray-200 bg-white px-3 py-1.5 text-xs text-gray-700 hover:bg-gray-50"
          >
            Delete
          </button>
        </div>
      </td>
    </tr>
  );
}
